import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import apiClient from "../../../services/apiClient";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../../../features/user/UserSlice";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { closeModal } from "../../../features/modal/ModalSlice";

const LoginWithEmail = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, setLoding] = useState(false);
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    setError("");
    setLoding(true);

    try {
      const payload = {
        email_id: data.email,
        password: data.password,
      };
      const response = await apiClient.post("/login", payload);
      console.log(response);

      dispatch(
        setUserDetails({
          id: response?.user?.id,
          company_id: response?.user?.company_id,
          name: response?.user?.name,
          email: response?.user?.email_id,
          phone_number: response?.user?.phone_number,
          image: response?.user?.image,
          role: response?.user?.user_type,
          company_domain: response?.user?.company_details?.domain,
        })
      );

      dispatch(closeModal());
      toast.success("Welcome");
      navigate("/");
    } catch (err) {
      console.log("err: ", err);
      if (err?.response?.data) {
        setError(err?.response?.data?.message);
      }
    } finally {
      setLoding(false);
    }
  };

  return (
    <>
      {error && <Form.Text className="text-danger">{error}</Form.Text>}
      <Form onSubmit={handleSubmit(onSubmit)} className="mt-4">
        <Form.Group controlId="formEmail" className="my-3">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter email"
            {...register("email", {
              required: "Email is required",
              pattern: { value: /^\S+@\S+$/i, message: "Invalid email address" },
            })}
          />
          {errors.email && <Form.Text className="text-danger">{errors.email.message}</Form.Text>}
        </Form.Group>

        <Form.Group controlId="formPassword" className="my-3">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Password"
            {...register("password", {
              required: "Password is required",
              minLength: { value: 6, message: "Password must be at least 6 characters" },
            })}
          />
          {errors.password && (
            <Form.Text className="text-danger">{errors.password.message}</Form.Text>
          )}
        </Form.Group>

        <button className="btn btn-primary custom-btn-full my-3" type="submit" disabled={loading}>
          {loading ? (
            <div className="spinner-border spinner-border-sm" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            "Login"
          )}
        </button>
      </Form>
    </>
  );
};

export default LoginWithEmail;
